// Active-tab indicator for the primary nav.
// The header nav is hardcoded (no Ghost {{navigation}}, so no `nav-current` class), and
// /archive/ renders via a custom route that gets no body class — so a CSS-only approach
// can't mark it. Match the link to the current path here. Portal CTAs (href^="#") skip.
// Progressive enhancement: without JS the nav still works, just without the underline.
export default function activeNav() {
    var here = location.pathname.replace(/\/+$/, "") || "/";
    var links = document.querySelectorAll(".gh-head-menu .nav a");
    links.forEach(function (a) {
        var href = a.getAttribute("href") || "";
        if (href.charAt(0) === "#") return; // skip Portal links (subscribe / account)
        var there;
        try {
            there = new URL(href, location.href).pathname.replace(/\/+$/, "") || "/";
        } catch (e) {
            return;
        }
        if (there === here) a.classList.add("is-active");
    });
}
